import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

const TWO_FA_COLLECTION = 'users_2fa';

const twoFactorService = {
  // Generate new 2FA secret and QR code
  generateSecret: async (userId, name) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/generateSecret`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, name: name })
      });
      
      if (!response.ok) throw new Error('Failed to generate secret');
      return await response.json();
    } catch (error) {
      console.error('Error generating 2FA secret:', error);
      throw error;
    }
  },

  // Verify OTP during setup or login
  verifyOTP: async (userId, otp) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/verify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, otp: otp })
      });
      
      if (!response.ok) throw new Error('Failed to verify OTP');
      return await response.json();
    } catch (error) {
      console.error('Error verifying OTP:', error);
      throw error;
    }
  },

  // Enable 2FA for a user
  enable2FA: async (userId, secret) => {
    try {
      const twoFARef = doc(db, TWO_FA_COLLECTION, userId);
      await setDoc(twoFARef, {
        user_id: userId,
        secret,
        enabled: true,
        created_at: new Date().toISOString()
      });
      return true;
    } catch (error) {
      console.error('Error enabling 2FA:', error);
      throw error;
    }
  },

  // Disable 2FA for a user
  disable2FA: async (userId) => {
    try {
      const twoFARef = doc(db, TWO_FA_COLLECTION, userId);
      await updateDoc(twoFARef, {
        enabled: false,
        secret: null
      });
      return true;
    } catch (error) {
      console.error('Error disabling 2FA:', error);
      throw error;
    }
  },

  // Check if 2FA is enabled for a user
  is2FAEnabled: async (userId) => {
    try {
      const twoFARef = doc(db, TWO_FA_COLLECTION, userId);
      const docSnap = await getDoc(twoFARef);
      if (!docSnap.exists()) return false;
      return docSnap.data().enabled;
    } catch (error) {
      console.error('Error checking 2FA status:', error);
      return false;
    }
  }
};

export default twoFactorService; 